import { InventoryDefinitionEntity } from '@/graphql/generated/graphql';

import { ALPHABET } from '../constants';

export const assignTitlesToLetters = (definitions: InventoryDefinitionEntity[]) => {
  const alphabetCopy = [...ALPHABET];

  alphabetCopy.forEach(({ letter, titles }) => {
    definitions.forEach((def) => {
      const title = def.attributes?.slug.replaceAll('-', ' ');
      const slug = def.attributes?.slug as string;

      if (title?.toUpperCase().startsWith(letter) && !titles.some((val) => val.title === title)) {
        titles.push({ title, slug });
      }
    });
  });

  const sortedAlphabetCopy = alphabetCopy.map((alphabet) => {
    return {
      letter: alphabet.letter,
      titles: alphabet.titles.length > 0 ? alphabet.titles.sort((a, b) => a.title.localeCompare(b.title)) : [],
    };
  });

  return sortedAlphabetCopy;
};
